import React from 'react';
import {
  Box, Paper, Typography, Button, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, useTheme, alpha,
} from '@mui/material';
import { Add as AddIcon, Link as LinkIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';

const SupplierWineLinkList: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { supplierId } = useParams<{ supplierId: string }>();

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <Box sx={{ px: 3, py: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${alpha(theme.palette.divider, 0.12)}` }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <LinkIcon sx={{ color: theme.palette.primary.main }} />
            <Typography variant="h6" fontWeight={600}>Linked Wines</Typography>
          </Box>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(`/admin/suppliers/${supplierId}/wines/add`)} sx={{ textTransform: 'none', fontWeight: 600 }}>
            Link Wine
          </Button>
        </Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {['Wine', 'Vintage', 'Supplier SKU', 'List Price', 'Preferred', ''].map(h => (
                  <TableCell key={h} sx={{ fontWeight: 600, color: theme.palette.text.secondary, fontSize: '0.75rem', textTransform: 'uppercase' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell colSpan={6}>
                  <Box sx={{ py: 5, textAlign: 'center', color: theme.palette.text.secondary }}>
                    <Typography variant="body2">No wines linked — Phase 9.</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default SupplierWineLinkList;
